<!--
 * @Author: 冯杰
 * @Date: 2021-08-09 16:38:37
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-04-14 10:18:10
 * @FilePath: \crm2.0\found\views\cps\views\execute\package\table\components\city.vue
-->
<template>
  <div>
    <el-date-picker
      style="width: 100%;"
      v-model="year"
      type="year"
      placeholder="选择年"
      value-format="yyyy"
      @change="changeYear"
      clearable
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: '',
      clear: false,
    };
  },
  props: ['value'],
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.year = '';
        }
      },
    },
  },
  mounted() {},
  methods: {
    changeYear() {
      this.$emit('getCustomData', this.year);
    },
  },
};
</script>
